import styles from "../rankings.module.css";

/**
 * Simple season points timeline for a player ranking projection.
 */
export default function PlayerRankingTimeline({ ranking }) {
  if (!ranking) return null;
  const items = [
    {
      id: "season",
      label: `Season ${ranking.seasonYear || ""} points`,
      value: `${ranking.season?.points ?? ranking.overall?.points ?? 0} pts`,
    },
    {
      id: "titles",
      label: "Career titles",
      value: String(ranking.profileStats?.careerTitles ?? 0),
    },
    {
      id: "finals",
      label: "Finals reached",
      value: String(ranking.profileStats?.finals ?? 0),
    },
    {
      id: "rank",
      label: "Current rank",
      value:
        ranking.profileStats?.currentRanking != null
          ? `#${ranking.profileStats.currentRanking}`
          : "Unranked",
    },
    {
      id: "best",
      label: "Highest rank",
      value:
        ranking.profileStats?.highestRanking != null
          ? `#${ranking.profileStats.highestRanking}`
          : "—",
    },
  ];
  return (
    <div className={styles.timeline} data-testid="ranking-timeline">
      {items.map((it) => (
        <div key={it.id} className={styles.timelineItem}>
          <span>{it.label}</span>
          <strong>{it.value}</strong>
        </div>
      ))}
    </div>
  );
}
